import cloneDeep from 'lodash/cloneDeep'

import { successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'
import useUpdateContentMutation from 'features/unifiedFlow/api/mutations/useUpdateContentMutation'
import { ContentWithProgress } from 'features/unifiedFlow/api/queries/useGetContentQuery'
import { parseWorkflowName } from 'features/unifiedFlow/contentPage/helpers'

export const useWorkflowName = (content: ContentWithProgress | undefined) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const updateContentMutation = useUpdateContentMutation()

  const updateWorkflowName = (value: string) => {
    const { value: parsedValue, isValid } = parseWorkflowName(value)
    if (!content || !isValid) {
      return
    }

    const userInputForm = cloneDeep(content.user_input.user_input_form)

    let previousName = ''
    userInputForm.forEach((field) => {
      if (field.name === 'workflow_name') {
        previousName = field.value as string
        field.value = parsedValue
      }
    })

    if (previousName !== value) {
      updateContentMutation.mutate(
        {
          contentId: content._id,
          accountId,
          userInputForm,
          updatedName: parsedValue,
        },
        {
          onSuccess: () => {
            successToast('Workflow name updated successfully')
          },
        }
      )
    }
  }

  return { updateWorkflowName }
}
